import { useRef, useState, useEffect } from "react";
import { DONUT_CHART_PALETTE, TAILWIND_TO_CSS } from "utils/constant/STYLE";

function WeightBarChart({
  data,
  height = 30,
  filedName = "WEIGHT",
  setWidth: setWidth_,
  top3 = false,
  activeIndex,
}: {
  data: any[];
  height?: number;
  filedName?: string;
  setWidth?: (width: number) => void;
  top3?: boolean;
  activeIndex?: number;
}) {
  const wrapDiv = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  console.log("width", width);

  useEffect(() => {
    if (!data) return;

    const updateWidth = () => {
      if (wrapDiv.current) {
        setWidth(wrapDiv.current.offsetWidth);
        setWidth_ && setWidth_(wrapDiv.current.offsetWidth);
      }
    };

    // 초기 너비 설정
    updateWidth();

    // ResizeObserver로 크기 변화 감지
    const resizeObserver = new ResizeObserver(updateWidth);
    if (wrapDiv.current) {
      resizeObserver.observe(wrapDiv.current);
    }

    // window resize 이벤트도 추가 (안전망)
    window.addEventListener("resize", updateWidth);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateWidth);
    };
  }, [data]);

  // PieChart와 동일한 데이터 구조 사용 (WEIGHT 속성)
  // top3가 true인 경우 top3만 컬러/데이터 분리, 그 외에는 weight, 컬러 합체(gray40)
  const items =
    !top3 || data?.length <= 3
      ? data?.map((item, index) => ({
          ...item,
          percentage: item?.[filedName] || 0, // WEIGHT는 이미 퍼센티지(0-1 범위)
          color: DONUT_CHART_PALETTE[index % DONUT_CHART_PALETTE.length],
        }))
      : [
          ...data?.slice(0, 3).map((item, index) => ({
            ...item,
            percentage: item?.[filedName] || 0, // WEIGHT는 이미 퍼센티지(0-1 범위)
            color: DONUT_CHART_PALETTE[index % DONUT_CHART_PALETTE.length],
          })),
          {
            percentage: data
              ?.slice(3)
              .reduce((acc, item) => acc + item?.[filedName] || 0, 0),
            color: TAILWIND_TO_CSS["gray40"],
          },
        ];

  return (
    <div
      ref={wrapDiv}
      className="w-full bg-transparent flex gap-[2px] rounded-lg overflow-hidden"
      style={{ height: `${height}px` }}
    >
      {width > 0 &&
        items.map((item, i) => (
          <div
            key={i}
            style={{
              width: `${item.percentage * width}px`,
              backgroundColor: item.color,
              opacity:
                activeIndex === undefined || activeIndex === i
                  ? 1
                  : activeIndex !== undefined && activeIndex !== i
                  ? 0.2
                  : 1,
            }}
          />
        ))}
    </div>
  );
}

export default WeightBarChart;
